<ng-content></ng-content>

<div
  class="google-map"
  fxLayout="column"
  fxLayout.gt-sm="row"
  fxLayoutAlign="center center"
  *ngIf="agencyService.agency"
  (click)="this.isHidden = true;"
>
  <app-gmaps-interface
    fxHide
    fxShow.gt-sm
    [travelModes]="travelModes"
    [isInfoHidden]="isHidden"
    (travelModeChanged)="changeTravelMode($event)"
  >
  </app-gmaps-interface>
  <agm-map
    [scrollwheel]="false"
    [latitude]="latitude | parseFloat"
    [longitude]="longitude | parseFloat"
    [zoom]="zoom"
    [styles]="customStyle"
    (mapClick)="updateDirectionsPath($event)"
  >
    <gmaps-directions
      [color]="pathColor"
    >
    </gmaps-directions>
    <agm-marker
      [latitude]="latitude | parseFloat"
      [longitude]="longitude | parseFloat"
      (markerClick)="clickedMarker(latitude, longitude)"
      [iconUrl]="'/assets/icons/pins/logo-pin.png'"
      appGtagEvent
      eventCategory="contact"
      eventAction="click"
      eventLabel="maps_click"
    >
    </agm-marker>
    <agm-marker
      *ngFor="let marker of customMarkers"
      [latitude]="marker.latitude | parseFloat"
      [longitude]="marker.longitude | parseFloat"
      (markerClick)="clickedMarker(marker.latitude, marker.longitude)"
      [iconUrl]="marker.iconUrl"
    >
      <agm-info-window
        [isOpen]="true"
        *ngIf="marker.infoWindow"
      >
        <img
          class="info-window-icon"
          *ngIf="marker.infoWindow.iconUrl"
          [src]="marker.infoWindow.iconUrl"
          alt=""
        >
        <span
          class="info-window-text"
          *ngIf="marker.infoWindow.text"
        >
          {{ marker.infoWindow.text }}
        </span>
      </agm-info-window>
    </agm-marker>
  </agm-map>
  <a
    [href]="'https://maps.google.com?daddr='
    + latitude + ','
    + longitude + '&amp;ll='"
    class="mobile-map"
    fxHide.gt-sm
    target="_blank"
    appGtagEvent
    eventCategory="contact"
    eventAction="click"
    eventLabel="maps_click"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      class="informations"
    >
      <img
        src="/assets/icons/contact/location.svg"
        alt=""
        class="icon"
      >
      <label
        translate
        class="text"
      >
        Vezi localizare pe hartă
      </label>
    </div>
  </a>
</div>



// WEBPACK FOOTER //
// ./src/app/common-theme/gmaps/google-map/google-map.component.html